import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const settings = {
  // gọi đến AuthServer connect/authorize xong mới redirect về Login.js
  // authority: 'https://108.108.108.51:8989',       // your AuthServer
  authority: 'https://api.authservice.cntt108.vn',       // your AuthServer
  client_id: 'qlkpic9_react_spa',//server
  //authority: 'https://localhost:5003',    // local   
  //.client_id: 'react_spa',//local
  redirect_uri: window.location.origin + '/callback',
  post_logout_redirect_uri: window.location.origin + '/',
  response_type: 'code',
  //scope: 'openid profile roles offline_access webapi.access', //local
  scope: 'openid profile roles offline_access qlkpic9.access',//server
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + '/silent-renew.html',
  silentRequestTimeoutInSeconds: 10,
  accessTokenExpiringNotificationTimeInSeconds: 30,
};

export const userManager = new UserManager(settings);

// convenience to read the currently signed in user
export function getUser() {
  return userManager.getUser();
}
